@if (!isNewEDPScoreboard) {
    <div class="event-description">{{ event.description }}</div>
}
@switch (type) {
    @case (scoreboardType.PairGame) {
        <ms-pair-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [showLogoColor]="true" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.Cricket) {
        <ms-cricket-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.Snooker) {
        <ms-snooker-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.SetGame) {
        <ms-set-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.Darts) {
        <ms-darts-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.LeaderboardGame) {
        <ms-leaderboard-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.BaseballGame) {
        <ms-baseball-scoreboard
            [isShowcase]="isShowcase"
            [event]="event"
            [scoreboard]="event.scoreboard"
            [showLogoColor]="true"
            [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.TournamentGame) {
        <ms-tournament-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.PeriodGame) {
        <ms-period-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [showLogoColor]="true" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.SpecialGame) {
        <ms-special-game-scoreboard [event]="event" [scoreboard]="event.scoreboard" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.PreMatchPairGame) {
        <ms-prematch-scoreboard
            [event]="event"
            [showPreMatchTimer]="showPreMatchTimer()"
            [showLogoColor]="true"
            [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
    @case (scoreboardType.PreMatchTournament) {
        <ms-prematch-tournament-scoreboard [event]="event" [isNewEDPScoreboard]="isNewEDPScoreboard" />
    }
}

@if (showStatsIcon) {
    <ms-statistics-button [event]="event" [scoreboard]="event.scoreboard" />
}
